// frontend/src/pages/AdminList.js

import React, { useState } from 'react';
import { Container, Jumbotron, Button, Form } from 'react-bootstrap';
import axios from "../libs/httpClient";
import { host } from '../libs/webRTC';
import UserTable from '../components/studentslist/BaseUserTable';

const AdminList = () => {
    const [revision, setRevision] = useState(0);
    const [login, setLogin] = useState('');
    const handleLoginChange = (e) => {
        setLogin(e.target.value);
    };

    const addInDBAsTeacher = () => {
        console.log("enroll", login);
        axios.post(`${host}/admin/enroll`, { login: login }).then(res => {
            console.log(res.data);
            fetchAdmins();
            setLogin('');
        });
    };

    const deleteAdminFromDB = () => {
        console.log("unenroll", login);
        axios.post(`${host}/admin/unenroll`, { login: login }).then(res => {
            console.log(res.data);
            fetchAdmins();
            setLogin('');
        });
    };

    const fetchAdmins = () => setRevision(value => value + 1);

    return (
        <div>
            <h3>Управление правами доступа (назначение роли преподавателя)</h3>
            <Form inline>
                <Form.Control
                    type="text"
                    name="login"
                    placeholder="Type login..."
                    value={login}
                    onChange={handleLoginChange}
                />
                <Button variant="success" onClick={addInDBAsTeacher} className="ml-2">
                    Добавить
                </Button>
                <Button variant="danger" onClick={deleteAdminFromDB} className="ml-2">
                    Удалить
                </Button>
            </Form>
            <h2>Преподаватели и администраторы</h2>
            <UserTable kind="admins" revision={revision} />
        </div>
    );
};

export default AdminList;
